import React, { Component } from "react";
import "./Footer.css";
// import Snackbar from "../Snackbar/Snackbar";
import Separator from "../Separator";

class Footer extends Component {
  render() {
    return (
      <div className="footer">
        <Separator />
        <div className="footer-block--container">
          <div className="footer-block">
            Веб-портал «Библиогород» развивается вместе с библиотеками Москвы и
            будет регулярно пополняться новыми функциями и возможностями.
            <div className="footer-links social">
             {/* <a
                href="https://www.facebook.com/MosLibrary/"
                className="facebook"
              />
              <a
                href="https://www.instagram.com/moslibrary/"
                className="insta"
              />
              <a href="https://twitter.com/mosbiblioteka" className="twitter" />*/}
              <a href="https://vk.com/moslibrary" className="vk" />
             {/* <a
                href="https://www.youtube.com/channel/UC8BFtTqtI5ocd6XC02KyIZw"
                className="yotube"
              />*/}
              <a
               href="https://t.me/mos_razvitie"
               className="telegramm"
              />
               <span> Канал «Культура Москвы» </span>
            </div>
          </div>
          <div
            className="footer-block"
            style={{
              display: "flex",
              flexFlow: "column",
              justifyContent: "space-between"
            }}
          >
            <p>За развитие библиотек Москвы на уровне города отвечают: Департамент культуры города Москвы; Московская дирекция по развитию культурных центров.
</p>
            <div
              className="footer-links"
              style={{ flex: "1 0 auto", width: "100%", margin: 0 }}
            >
              <a href="https://www.mos.ru/kultura/" className="departament" />
              <a href="https://mos-razvitie.mos.ru/" className="biblio" />
            </div>
          </div>
        </div>
        {/*<Snackbar />*/}
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js